export default __webpack_public_path__ + "static/media/grafema_gim-tonico_03.ec947851.jpg";